import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BannerApi = createApi({
  reducerPath: "BannerApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BANNERAPI"],
  endpoints: (build) => ({
    getBanner: build.query({
      query: ({ page, searchTerm }) => ({
        url: `/banner?page=${page}&search=${searchTerm}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BANNERAPI"],
    }),

    getBannerById: build.query({
      query: ({ id }) => ({
        url: `/banner/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BANNERAPI"],
    }),

    editBanner: build.mutation({
      query: ({ id, data }) => ({
        url: `/banner/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["BANNERAPI"],
    }),

    addBanner: build.mutation({
      query: ({ data }) => ({
        url: `/banner`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["BANNERAPI"],
    }),

    deleteBanner: build.mutation({
      query: ({ id }) => ({
        url: `/banner/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BANNERAPI"],
    }),
  }),
});

export const {
  useGetBannerQuery,
  useGetBannerByIdQuery,
  useEditBannerMutation,
  useAddBannerMutation,
  useDeleteBannerMutation,
} = BannerApi;
